import React from 'react';
import classes from './TopNav.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

const externalIcon = <FontAwesomeIcon icon={faExternalLinkAlt} />;

const TopNav = ({ children }) => (
  <div className={classes['top-nav']}>
    <ul>
      {React.Children.map(children, (child, index) => {
        if (!React.isValidElement(child)) {
          console.warn('TopNav received a child that is not a valid React element:', child);
          return <li key={index}>{child}</li>;
        }

        const displayName = child.type?.displayName || child.type?.name || '';

        if (displayName === 'Link' || displayName === 'NavLink') {
          return (
            <li key={index}>
              {React.cloneElement(child, { activeClassName: classes['active'] })}
            </li>
          );
        }

        return <li key={index}>{child}</li>;
      })}
      <li className={classes['flexer']} />
      <li className={classes['merch-link']}>
        <div>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.silvamysteriumclothing.fi"
          >
            SILVAMYSTERIUM CLOTHING{externalIcon}
          </a>
        </div>
      </li>
    </ul>
  </div>
);

TopNav.propTypes = {
  children: PropTypes.node,
};

export default TopNav;
